import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/plain-order-management',
      name: 'admin-plain-order-management',
      component: () => import(/* webpackChunkName: "page-admin-plain-order-management-plain-order-management" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "订单管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "订单管理"
                                        },
                                        {
                                                  name: "订单管理"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
